import React from 'react';
import GroupTable from 'components/UiKit/GroupTable';
import PropTypes from 'prop-types';
import CropZoneCell from '../CropZoneCell';

const deletedAndChangedTableViewDefaultPropMassiveChangeSummary = {};
const deletedAndChangedTableViewDefaultPropMappedCropView = [];
const DeletedAndChangedTableView = ({
  massiveChangeSummary = deletedAndChangedTableViewDefaultPropMassiveChangeSummary,
  mappedCropView = deletedAndChangedTableViewDefaultPropMappedCropView
}) => {
  return (
    <GroupTable>
      {Object.entries(mappedCropView).map(crop => (
        <GroupTable.RowGroup arrowIcon key={crop[0]}>
          <GroupTable.Row>
            <GroupTable.Cell>
              <p
                className="font-semibold font-body"
                data-testid="view-by-crops"
              >
                {crop[0]}
              </p>
            </GroupTable.Cell>
          </GroupTable.Row>
          {Object.entries(crop[1]).map(farm => (
            <GroupTable.RowGroup arrowIcon key={farm[0]}>
              <GroupTable.Row>
                <GroupTable.Cell>
                  <p className="font-semibold font-body">{farm[0]}</p>
                </GroupTable.Cell>
              </GroupTable.Row>
              {farm[1].map(property => {
                return (
                  <GroupTable.RowGroup arrowIcon key={property.id}>
                    <GroupTable.Row>
                      <GroupTable.Cell>
                        <p className="font-semibold font-body">
                          {property.name}
                        </p>
                      </GroupTable.Cell>
                    </GroupTable.Row>
                    <GroupTable.Row>
                      <GroupTable.Cell>
                        <CropZoneCell
                          massiveChangeSummary={massiveChangeSummary}
                          property={property}
                          cropName={crop[0]}
                          key={property.id}
                        />
                      </GroupTable.Cell>
                    </GroupTable.Row>
                  </GroupTable.RowGroup>
                );
              })}
            </GroupTable.RowGroup>
          ))}
        </GroupTable.RowGroup>
      ))}
    </GroupTable>
  );
};

DeletedAndChangedTableView.propTypes = {
  massiveChangeSummary: PropTypes.shape(),
  mappedCropView: PropTypes.arrayOf(PropTypes.array)
};

export default DeletedAndChangedTableView;
